import script from "./TransferPayments.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransferPayments.vue?vue&type=script&setup=true&lang=ts"

import "./TransferPayments.vue?vue&type=style&index=0&id=c9fb557e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9fb557e"]])

export default __exports__